import { Logger } from './logger';
export const logger = new Logger();
export { IPC_LOGGER_CHANNEL } from './ipcChannel';
